import styled, { css } from 'styled-components';
import { colors, getSpacing } from '../utils';

const baseStyles = css`
  color: ${props => props.color || colors.g05};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 400)};
  line-height: normal;
  text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
  margin: ${props => (props.margin ? getSpacing(props.margin) : 0)};
  padding: ${props => (props.padding ? getSpacing(props.padding) : 0)};
`;

export const H1 = styled.h1`
  ${baseStyles};
  font-size: ${props => props.fontSize}px;
`;

H1.defaultProps = {
  fontSize: 28
};

export const H2 = styled.h2`
  ${baseStyles};
  font-size: ${props => props.fontSize}px;
`;

H2.defaultProps = {
  fontSize: 24
};

export const H3 = styled.h3`
  ${baseStyles};
  font-size: ${props => props.fontSize}px;
`;

H3.defaultProps = {
  fontSize: 20
};

export const Typography = styled.p`
  ${baseStyles};
  font-size: 16px;
  line-height: normal;
`;

export const Hints = styled.p`
  ${baseStyles};
  font-size: 12px;
  line-height: normal;
`;

export const Tags = styled.p`
  color: ${colors.t03};
  font-size: 16px;
  line-height: normal;
`;

export const LinkText = styled.a`
  ${baseStyles};
  font-size: ${props => props.fontSize}px
  line-height: normal;
  text-decoration: underline;
  cursor: pointer;
`;
